import CatalogsEthPage from "./CatalogsEthsPage";

export default CatalogsEthPage;
